<template>
  <div ref="participantForm">
    <v-container fluid grid-list-xl>
      <v-layout wrap v-if="can('edit', 'tournament', tournament)">
        <v-flex v-if="tournament.type != 'users'" d-flex md4 xs12>
          <v-autocomplete
            :items="listTeams.filter(item => !participantList.some(p =>p.teamId == item.value) || item.value == participant.teamId)"
            :label="$t('select', {field: $tc('team')})"
            :disabled="participant._id"
            v-model="participant.teamId"
          ></v-autocomplete>
        </v-flex>
        <v-flex v-if="tournament.type =='users'" d-flex md4 xs12>
          <v-autocomplete
            v-if="tournament.type =='users'"
            :items="users"
            :disabled="participant._id"
            :label="$t('select', {field: $tc('user')})"
            v-model="participant.userId"
          >
            <template v-slot:selection="data">
              <v-chip color="white"  class="chip--select-multi">
                <v-avatar>
                  <img :src="data.item.photo" />
                </v-avatar>
                {{ data.item.text }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-avatar>
                <img :src="data.item.photo" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{data.item.text}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="data.item.teams" class="caption">
                  <v-chip class="my-0" small v-for="team of data.item.teams" :key="team._id">
                    <v-avatar v-if="team.logo">
                      <v-img :src="team.logo" />
                    </v-avatar>
                    <span class="caption">{{ team.name }}</span>
                  </v-chip>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex v-if="tournament.type == 'usersTeams'" d-flex md8 xs12>
          <v-autocomplete
            v-model="participant.userIds"
            :items="users"
            item-text="text"
            :label="$t('select', {field: $tc('user',2)})"
            :disabled="!participant.teamId"
            multiple
            clearable
            @change="searchUser = ''"
            :search-input.sync="searchUser"
          >
            <template v-slot:selection="data">
              <v-chip color="white" :selected="data.selected" class="chip--select-multi">
                <v-avatar>
                  <img :src="data.item.photo" />
                </v-avatar>
                {{ data.item.text }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-avatar>
                <img :src="data.item.photo" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{data.item.text}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="data.item.teams" class="caption">
                  <v-chip class="my-0" small v-for="team of data.item.teams" :key="team._id">
                    <v-avatar v-if="team.logo">
                      <v-img :src="team.logo" />
                    </v-avatar>
                    <span class="caption">{{ team.name }}</span>
                  </v-chip>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex md2 sm4 xs12>
          <v-switch v-model="participant.confirmed" :label="$t('isConfirmed')" color="primary"></v-switch>
        </v-flex>
        <v-flex md2 sm4 xs12>
          <v-switch v-model="participant.accepted" :label="$t('ifAccepted')" color="primary"></v-switch>
        </v-flex>
        <v-flex md2 sm4 xs12>
          <v-switch
            v-model="participant.invitationSent"
            :label="$t('ifInvitationSent')"
            color="primary"
          ></v-switch>
        </v-flex>
        <v-flex xs12 text-xs-right>
          <v-btn
            small
            color="warning"
            @click="participant = Object.assign({}, templateParticipant())"
            :disabled="!Edit  && !participant._id"
          >{{$t('reset')}}</v-btn>
          <v-btn
            small
            :color="participant._id ? 'secondary' : 'success'"
            @click="addParticipant()"
            :disabled="!Edit && !participant._id"
          >{{participant._id ? $t('update') :$t('add')}}</v-btn>
        </v-flex>
        <v-flex xs12 text-xs-center></v-flex>
      </v-layout>
    </v-container>
    <template v-if="participantList.length">
      <v-chip
        :color="limit - countParticipants > 0? 'primary' :'error'"
        text-color="white"
      >{{$t('left')}}: {{limit - countParticipants}}</v-chip>
      <v-progress-circular v-if="loading" :size="30" :width="3" color="primary" indeterminate></v-progress-circular>

      <v-container>
        <v-layout row wrap>
          <v-flex lg12>
            <v-card>
              <v-toolbar card color="white">
                <v-text-field
                  flat
                  hide-details
                  :placeholder="$t('search')"
                  prepend-icon="search"
                  solo
                  v-model="search"
                ></v-text-field>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="text-xs-center pa-0">
                <v-data-table
                  :headers="complex.headers"
                  :items="formatList"
                  :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                  :search="search"
                  class="elevation-1"
                  :loading="loading"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <template v-if="can('edit', 'tournament', tournament)">
                        <v-tooltip top v-if="!props.item.accepted">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              @click="acceptParticipant(props.item._id)"
                              v-on="on"
                              flat
                              small
                              icon
                              color="success"
                              class="mx-0"
                            >
                              <v-icon class="icon material-icons">check</v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('accept')}}</span>
                        </v-tooltip>
                        <v-tooltip
                          top
                          v-if="!props.item.invitationSent && !(props.item.accepted &&props.item.confirmed)"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              @click="sendInvitation(props.item._id)"
                              v-on="on"
                              flat
                              small
                              icon
                              color="primary"
                              class="mx-0"
                            >
                              <v-icon class="icon material-icons">message</v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('invite')}}</span>
                        </v-tooltip>
                        <v-btn
                          @click="setParticipant(props.item._id)"
                          flat
                          small
                          icon
                          color="secondary"
                          class="mx-0"
                        >
                          <v-icon class="icon material-icons">edit</v-icon>
                        </v-btn>
                        <v-btn
                          @click="remove(props.item._id)"
                          flat
                          icon
                          small
                          color="error"
                          class="mx-0"
                        >
                          <v-icon class="icon material-icons">delete</v-icon>
                        </v-btn>
                      </template>
                    </td>
                    <td>{{props.item.name}}</td>
                    <td v-if="type == 'usersTeams'">{{props.item.users}}</td>
                    <td>
                      <i
                        v-if="props.item.confirmed"
                        class="success--text icon material-icons subheading"
                      >check_circle</i>
                      <i v-else class="error--text icon material-icons subheading">cancel</i>
                    </td>
                    <td>
                      <i
                        v-if="props.item.accepted"
                        class="success--text icon material-icons subheading"
                      >check_circle</i>
                      <i v-else class="error--text icon material-icons subheading">cancel</i>
                    </td>
                    <td class="justify-center align-self-center">
                      <i
                        v-if="props.item.invitationSent"
                        class="success--text icon material-icons subheading"
                      >check_circle</i>
                      <i v-else class="error--text icon material-icons subheading">cancel</i>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
        <v-card-text v-html="$t('confirmDelete', {field: $tc('team')})"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color small flat="flat" @click="dialog = false">{{$t('cancel')}}</v-btn>

          <v-btn color="error" flat="flat" @click="deleteTeam()">
            <span v-if="loading">
              <v-progress-circular :size="20" :width="3" color="red" indeterminate></v-progress-circular>
            </span>
            <span v-else>{{$t('delete')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'

export default {
  name: 'tabParticipants',
  props: {
    editar: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      searchUser: '',
      search: '',
      dialog: false,
      loading: false,
      selected: -1,
      participant: {},
      participantList: []
    }
  },
  mounted() {
    this.resetLocal()
  },
  watch: {
    tournament(val) {
      if (val._id) this.resetLocal()
    }
  },
  computed: {
    ...mapState({
      listTeams: state => state.teams.listSelectTeams,
      listUsers: state => state.users.listSelectUsers,
      tournamentId: state => state.tournaments.idSelected,
      tournament: state => state.tournaments.selected
    }),
    type() {
      if (this.tournament && this.tournament.type) {
        return this.tournament.type
      } else return ''
    },
    complex() {
      let headers = [
        {
          text: this.$t('actions'),
          align: 'center',
          value: 'actions'
        },
        {
          text: this.$t('name'),
          align: 'center',
          value: 'name'
        }
      ]
      if (this.type == 'usersTeams') {
        headers.push({
          text: this.$tc('user', 2),
          align: 'center',
          value: 'users'
        })
      }
      headers = headers.concat([
        {
          text: this.$t('isConfirmed'),
          align: 'center',
          value: 'confirmed'
        },
        {
          text: this.$t('ifAccepted'),
          align: 'center',
          value: 'accepted'
        },
        {
          text: this.$t('ifInvitationSent'),
          align: 'center',
          value: 'invitationSent'
        }
      ])
      return {
        headers
      }
    },
    users() {
      if (this.type == 'teams') return []

      let users = this.listUsers.filter(user =>
        user.roles.includes('participant')
      )
      if (this.type == 'users') {
        users = users.filter(
          user =>
            !this.participantList.some(p => p.userId == user.value) ||
            user.value == this.participant.userId
        )
      } else if (this.type == 'usersTeams') {
        users = users.filter(user =>
          user.teamIds.includes(this.participant.teamId)
        )
      }
      return users
    },
    limit() {
      return Number(this.tournament.numberParticipants)
    },
    Edit() {
      if (this.countParticipants >= this.limit) return false
      else return this.editar
    },
    formatList() {
      return this.participantList.map((participant, index) => {
        let result = {
          ...participant,
          name: this.formatType(this.type, participant),
          index
        }
        if (this.type == 'usersTeams') {
          let users = participant.userIds.map(userId => this.formatUser(userId))
          result.users = users.join(', ')
        }
        return result
      })
    },
    countParticipants() {
      let participants = []
      if (this.type == 'teams' || this.type == 'usersTeams') {
        participants = this.tournament.teams || []
      }
      if (this.type == 'users') {
        participants = this.tournament.users || []
      }

      let count = participants.filter(item => item.confirmed && item.accepted)
      return count.length
    }
  },
  methods: {
    ...mapActions({
      setUpdate: 'tournaments/setUpdate'
    }),
    templateParticipant: () => {
      return {
        userId: '',
        teamId: '',
        userIds: [],
        confirmed: false,
        accepted: false,
        invitationSent: false
      }
    },
    setParticipant(id) {
      let participant = this.participantList.find(
        participant => participant._id == id
      )
      if (participant) {
        this.participant = Object.assign({}, participant)
      }

      this.$refs.participantForm.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },
    validateTeams() {
      let error = true
      let messages = []
      if (this.type === 'teams' || this.type == 'usersTeams') {
        if (!this.participant.teamId) {
          error = false
          messages.push(this.$t('error.required', { field: this.$tc('team') }))
        }
      }
      if (this.type === 'users') {
        if (!this.participant.userId) {
          error = false
          messages.push(this.$t('error.required', { field: this.$tc('user') }))
        }
      }
      if (this.type == 'usersTeams') {
        if (!this.participant.userIds.length) {
          error = false
          messages.push(
            this.$t('error.required', { field: this.$tc('user', 2) })
          )
        }
      }
      return {
        error,
        messages
      }
    },
    addParticipant() {
      this.selected = -1
      const validate = this.validateTeams()
      if (!validate.error) {
        queueToast(validate.messages)
        return
      }
      let payload = Object.assign({}, this.participant)
      if (this.type == 'users') {
        delete payload.teamId
        delete payload.userIds
      } else {
        delete payload.userId
      }

      if (payload._id) {
        let index = this.participantList.findIndex(
          participant => participant._id == payload._id
        )
        this.participantList.splice(index, 1)
      }
      this.participantList.push(payload)
      this.updateParticipants()
      this.participant = Object.assign({}, this.templateParticipant())
    },

    remove(id) {
      this.selected = id
      this.dialog = true
    },
    deleteTeam() {
      let index = this.participantList.findIndex(
        participant => participant._id == this.selected
      )
      this.participantList.splice(index, 1)
      this.updateParticipants()
    },
    sendInvitation(id) {
      let participant = this.participantList.find(
        participant => participant._id == id
      )
      participant.invitationSent = true
      this.updateParticipants()
    },
    acceptParticipant(id) {
      let participant = this.participantList.find(
        participant => participant._id == id
      )
      participant.accepted = true
      this.updateParticipants()
    },
    formatType(type, participant) {
      let result = ''
      if (type === 'teams' || type == 'usersTeams') {
        result = this.listTeams.find(item => item.value === participant.teamId)
        return result ? result.text : ''
      }
      if (type === 'users') {
        result = this.listUsers.find(item => item.value === participant.userId)
        return result ? result.text : ''
      }

      return type
        ? this.$t('modelNotFound', { field: type.substring(0, 4) })
        : ''
    },
    resetLocal() {
      this.participant = Object.assign({}, this.templateParticipant())
      if (this.type == 'teams' || this.type == 'usersTeams') {
        this.participantList = this.tournament.teams.slice()
      } else if (this.type == 'users') {
        this.participantList = this.tournament.users.slice()
      } else this.participantList = []
    },
    updateParticipants() {
      let tournament = {}
      tournament._id = this.tournament._id
      if (this.type == 'teams') {
        tournament.teams = this.participantList
        tournament.users = []
      } else if (this.type == 'users') {
        tournament.users = this.participantList
        tournament.teams = []
      } else if (this.type == 'usersTeams') {
        tournament.teams = this.participantList
        tournament.users = []
        tournament.teams.forEach(team => {
          let users = team.userIds.map(userId => {
            return {
              userId,
              confirmed: team.confirmed,
              accepted: team.accepted,
              invitationSent: team.invitationSent
            }
          })
          tournament.users = tournament.users.concat(users)
        })
      } else return
      this.loading = true
      this.setUpdate(tournament)
        .then(() => (this.dialog = false))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  max-width: none !important;
}
</style>
